module.exports = __webpack_public_path__ + "img/doctor-patient.ddfd56aa.svg";